const FOCUSABLE_ELEMENTS = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]:not([tabindex^="-"])'];

function getFocusableElements(el) {
    return Array.prototype.slice.call(
        el.querySelectorAll(FOCUSABLE_ELEMENTS.join(','))
    )
}

function toggleTabIndex(parent, visible) {
    const els = getFocusableElements(parent);

    els.forEach((el) => {
        if (visible) {
            el.removeAttribute('tabindex');
        } else {
            el.setAttribute('tabindex', -1);
        }
    });
}

export {
    toggleTabIndex,
};
